import React, { useState,useEffect } from "react";
import {
  Grid,
  Paper,
  Typography,
  TextField,
  Box,
  Button,
  MenuItem,
  DialogActions,
  Autocomplete
} from "@mui/material";
import axiosInstance from '../../../helpers/axios';


const relatedOptions = ["Spouse", "Parent", "Guardian", "Friend"];



export default function CoApplicationForm(coApplicantUserData) {

  const [changedFields, setChangedFields] = useState({});
  const [formData, setFormData] = useState({
    applicationId: "",
    userId: "",
    mobile: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    gender: "",
    relation: "",
    employmentType: "",
    employerName: "",
    salary: "",
    typeOfBusiness: "",
    email: "",
    currentAddress: "",
    currentCity: "",
    currentState: "",
    whatsappNumber: "",
    panId: "",
    aadhaarId: "",
  });
  const user = null;

    useEffect(() => {
    if (coApplicantUserData) {
      setFormData({
        applicationId:coApplicantUserData.coApplicantUserData.applicationId,
        userId: coApplicantUserData.coApplicantUserData.userId,
        mobile: coApplicantUserData.coApplicantUserData.mobile,
        firstName: coApplicantUserData.coApplicantUserData.firstName,
        lastName: coApplicantUserData.coApplicantUserData.lastName,
        dateOfBirth: coApplicantUserData.coApplicantUserData.dateOfBirth,
        gender: coApplicantUserData.coApplicantUserData.gender,
        relation: coApplicantUserData.coApplicantUserData.relation,
        employmentType: coApplicantUserData.coApplicantUserData.employmentType,
        employerName: coApplicantUserData.coApplicantUserData.employerName,
        salary: coApplicantUserData.coApplicantUserData.salary,
        typeOfBusiness: coApplicantUserData.coApplicantUserData.typeOfBusiness,
        email: coApplicantUserData.coApplicantUserData.email,
        incomePerMonth:coApplicantUserData.coApplicantUserData.incomePerMonth,
        currentAddress: coApplicantUserData.coApplicantUserData.currentAddress,
        currentCity: coApplicantUserData.coApplicantUserData.currentCity,
        currentState: coApplicantUserData.coApplicantUserData.currentState,
        whatsappNumber: coApplicantUserData.coApplicantUserData.whatsappNumber,
        panId: coApplicantUserData.coApplicantUserData.panId,
        aadhaarId: coApplicantUserData.coApplicantUserData.aadhaarId,
          });
        }
      }, [coApplicantUserData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setChangedFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {

  if (Object.keys(changedFields).length === 0) {
    alert("No changes made to save");
    return;
  }
 
 
  const payload = {
      applicationId: formData.applicationId,
      userId: formData.userId,
      aadhaarId:formData.aadhaarId,
    ...changedFields, 
  };

  try {
   
    const response = await axiosInstance.post("/summary/updatecoapplicant", payload, {
      headers: {
      },
    });

    alert(`Details Updated ${response.data.message}`);


    setTimeout(() => {
      window.location.reload();
    }, 1000);
  } catch (error) {
    console.error("Error updating data:", error);
    alert("Failed to update details. Please try again.");
  }
};




  return (
    <Paper sx={{ p: 3, maxWidth: 900, margin: "auto" }}>
     
            <Box 
                sx={{
                    backgroundColor: '#fafafa',  
                    padding: 2,                  
                    borderRadius: 1,
                      marginTop:'10px'             
                }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Basic Information
            </Typography>     
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                variant="outlined"
                label="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                variant="outlined"
                label="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                variant="outlined"
                label="Mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                fullWidth
                type="tel"
              />
            </Grid>
          
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                variant="outlined"
                label="Date of Birth"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                fullWidth
                type="date"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                variant="outlined"
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                variant="outlined"
                select
                label="Gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                fullWidth
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
               <Autocomplete
              size="small"
              options={relatedOptions}
              value={formData.relation || null}
              onChange={(event, newValue) => {
                handleChange({ target: { name: "relation", value: newValue || "" } });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Relation"
                  variant="outlined"
                  fullWidth
                />
              )}
              clearOnEscape
            />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Pan Number"
                name="panId"
                variant="outlined"
                fullWidth
                type="string"
                value={formData.panId}
                onChange={handleChange}
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Aadhaar Number"
              name="aadhaarId"
              variant="outlined"
              fullWidth
              value={formData.aadhaarId || ""}
              onChange={handleChange}
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          </Grid>
        </Box>

        <Box  style={{
                backgroundColor: '#fafafa',  
                padding: '16px',
                borderRadius: '4px',
                marginTop:'10px'
            }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                       Employment Information
         </Typography>
          <Grid container spacing={2}>
      {/* Employment Type Dropdown */}
      <Grid item xs={12} sm={6}>
        <TextField
          size="small"
          variant="outlined"
          select
          label="Employment Type"
          name="employmentType"
          value={formData.employmentType}
          onChange={handleChange}
          fullWidth
          InputLabelProps={{ shrink: true }}
        >
          <MenuItem value="">Select</MenuItem>
          <MenuItem value="salaried">Salaried</MenuItem>
          <MenuItem value="self-employed">Self-Employed</MenuItem>
          <MenuItem value="unemployed">Unemployed</MenuItem>
        </TextField>
      </Grid>

      {/* Employer Name */}
      <Grid item xs={12} sm={6}>
        <TextField
          size="small"
          variant="outlined"
          label="Employer Name"
          name="employerName"
          value={formData.employerName}
          onChange={handleChange}
          fullWidth
          disabled={formData.employmentType !== "salaried"}
           InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Salary */}
      <Grid item xs={12} sm={6}>
        <TextField
          size="small"
          variant="outlined"
          label="Salary"
          name="salary"
          value={formData.salary}
          onChange={handleChange}
          fullWidth
          type="number"
          disabled={formData.employmentType !== "salaried"}
           InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Type of Business */}
      <Grid item xs={12} sm={6}>
        <TextField
          size="small"
          variant="outlined"
          label="Type of Business"
          name="typeOfBusiness"
          value={formData.typeOfBusiness}
          onChange={handleChange}
          fullWidth
          disabled={formData.employmentType === "salaried"}
           InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Income Per Month */}
      <Grid item xs={12} sm={6}>
        <TextField
          size="small"
          variant="outlined"
          label="Income Per Month"
          name="incomePerMonth"
          value={formData.incomePerMonth}
          onChange={handleChange}
          fullWidth
          type="number"
          disabled={formData.employmentType === "salaried"}
           InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </Grid>
        </Box>

        <Box   style={{
                backgroundColor: '#fafafa',  
                padding: '16px',
                borderRadius: '4px',
                marginTop:'10px'
            }}>
     <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                       Address Information
                      </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                size="small"
                variant="outlined"
                label="Current Address"
                name="currentAddress"
                value={formData.currentAddress}
                onChange={handleChange}
                fullWidth
                multiline
                rows={2}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                variant="outlined"
                label="Current City"
                name="currentCity"
                value={formData.currentCity}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                variant="outlined"
                label="Current State"
                name="currentState"
                value={formData.currentState}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>

      <DialogActions sx={{ bgcolor: '#f5f5f5', py: 1.5, justifyContent: 'center' }}>
                <Button 
                  variant="contained" 
                  onClick={handleSave}
                  sx={{ 
                    bgcolor: '#D32028', 
                    '&:hover': { bgcolor: '#BD1C23' },
                    borderRadius: '20px',
                    px: 4
                  }}
                >
                  Save
                </Button>
              </DialogActions>
     
    </Paper>
  );
}
